// extracted by mini-css-extract-plugin
export var explainable = "_h2-a";
export var printerCard = "_h2-1";
export var printerCardConfigured = "_h2-2";
export var printerCardError = "_h2-3";
export var printerCardsContainer = "_h2-0";
export var printerIcon = "_h2-8";
export var printerIconConfigured = "_h2-5";
export var printerIconContainer = "_h2-4";
export var printerIconError = "_h2-6";
export var printerIconUnconfigured = "_h2-7";
export var workstationsTableCard = "_h2-9";